import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface PontoDia {
    ano: number
    mes: number
    dia: number
    label: string
    decimal: number
    decimal2: number
    valor: number
    valor2: number
}

export interface PontoMes {
    ano: number
    mes: number
    decimal: number
    valor2: number
}

export interface PontoTipo {
    nome: string
    label: string
    decimal2: number
}

export interface PontoExtra {
    nome: string
    valor2: number
}

export interface PontoProduto {
    nome: string
    valor: number
    decimal: number
}

export interface PontoCliente {
    nome: string
    label: string
    decimal: number
    decimal2: number
}

export interface KpisResumo {
    totalPedidos: number
    totalVendido: number
    totalClientes: number
    ticketMedio: number
    frequenciaMedia: number
    clientesAtivos: number
    nps: number
    qtdPix: number
    valorPix: number
}

export interface ResumoDashboard {
    possuiDelivery: boolean
    kpis: KpisResumo
    pontosFaturamento: PontoDia[]
    pontosExpirado: PontoDia[]
    pontosMes: PontoMes[]
    pontosMesVendasTipo: PontoTipo[]
    pontosInfoExtras: PontoExtra[]
    pontosProdutoMaisVendido: PontoProduto[]
    melhoresClientes: PontoCliente[]
    totalExpirados: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterResumoDashboard = async function (
    authorization: string,
    dataInicio: string,
    dataFim: string
): Promise<ResumoDashboard | ErroApi> {
    try {
        // ObterResumoDashboardLoja respeita a loja selecionada (header "estabelecimento",
        // enviado pelo interceptor do api) e honra o horário nas datas (janela 06:00 do início).
        const response = await api
            .get<ResumoDashboard | RespostaErroRaw>("fornecedor/ObterResumoDashboardLoja", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
                params: { dataInicio, dataFim },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as ResumoDashboard
    } catch (error) {
        RegistrarLogErro(error, "ObterResumoDashboardLoja", `${dataInicio}/${dataFim}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
